import React, { Fragment } from 'react';

const NotFound = () => {
  return (
    <Fragment>
      <h1>Not Found</h1>
      <p className="lead">The page you're looking for does not exist...</p>
    </Fragment>
  );
};

export default NotFound;
